import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5b36dcb9&scoped=true&lang=pug&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=5b36dcb9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b36dcb9",
  null
  
)

export default component.exports